import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPressure = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Group_2355",
		"data-name": "Group 2355",
		transform: "translate(-266 -279)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_2354",
			"data-name": "Group 2354",
			transform: "translate(266 279)",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group_2353",
				"data-name": "Group 2353",
				transform: "translate(1.275 3.657)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Path_2152",
					"data-name": "Path 2152",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_2231",
						"data-name": "Path 2231",
						d: "M246.926,156.935c-2.374,0-2.886-3.045-3.167-4.716-.051-.306-.1-.582-.147-.806-.067-.3-.215-.761-.387-1.3a15.379,15.379,0,0,1-.925-4.075,6.623,6.623,0,0,1,1.8-4.813,3.52,3.52,0,0,1,2.716-.97c2.141.156,3.262,2.532,3.262,4.8a8.759,8.759,0,0,1-.465,2.7,5.465,5.465,0,0,0-.311,1.577,13.762,13.762,0,0,0,.2,1.821c.25,1.683.534,3.592-.378,4.784a2.594,2.594,0,0,1-1.843.974h0A3,3,0,0,1,246.926,156.935Zm-.383-15.187a2.038,2.038,0,0,0-1.423.578,5.2,5.2,0,0,0-1.32,3.715,14.828,14.828,0,0,0,.853,3.617c.182.57.34,1.063.422,1.427.055.245.106.549.163.885.384,2.282.813,3.577,1.865,3.455a1.1,1.1,0,0,0,.827-.4c.527-.688.282-2.332.086-3.652a14.7,14.7,0,0,1-.214-2.042,6.783,6.783,0,0,1,.374-2.005,7.4,7.4,0,0,0,.4-2.271c0-1.558-.7-3.219-1.871-3.3C246.652,141.75,246.6,141.748,246.543,141.748Z",
						transform: "translate(-242.301 -140.248)",
						fill: "current"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Path_2153",
					"data-name": "Path 2153",
					transform: "translate(13.675 0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_2232",
						"data-name": "Path 2232",
						d: "M281.939,156.935a3,3,0,0,1-.35-.021h0a2.594,2.594,0,0,1-1.843-.974c-.913-1.192-.629-3.1-.378-4.784a13.816,13.816,0,0,0,.2-1.821,5.453,5.453,0,0,0-.311-1.577,8.771,8.771,0,0,1-.465-2.7c0-2.267,1.12-4.644,3.262-4.8a3.525,3.525,0,0,1,2.715.97,6.622,6.622,0,0,1,1.8,4.813,15.365,15.365,0,0,1-.925,4.075c-.171.536-.319,1-.386,1.3-.051.224-.1.5-.148.807C284.825,153.89,284.312,156.935,281.939,156.935Zm-.176-1.51c1.062.124,1.481-1.174,1.865-3.455.056-.336.108-.639.163-.885.081-.364.239-.856.422-1.426a14.828,14.828,0,0,0,.853-3.617,5.2,5.2,0,0,0-1.32-3.715,2.04,2.04,0,0,0-1.586-.572c-1.171.085-1.871,1.747-1.871,3.3a7.415,7.415,0,0,0,.4,2.271,6.783,6.783,0,0,1,.374,2.005,14.7,14.7,0,0,1-.214,2.042c-.2,1.32-.441,2.964.086,3.652a1.1,1.1,0,0,0,.827.4Z",
						transform: "translate(-278.789 -140.249)",
						fill: "current"
					})
				})]
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_2233",
				"data-name": "Path 2233",
				d: "M263.812,158.617l2,2a.728.728,0,0,0,.115.094c.018.012.037.02.056.03s.048.028.073.039a.748.748,0,0,0,.075.023c.022.006.042.015.065.019a.744.744,0,0,0,.293,0c.022,0,.043-.013.065-.019a.741.741,0,0,0,.075-.023.8.8,0,0,0,.073-.039c.019-.01.038-.018.056-.03a.726.726,0,0,0,.115-.094l2-2a.75.75,0,1,0-1.06-1.06l-.717.717v-7.568a.75.75,0,1,0-1.5,0v7.568l-.717-.717a.75.75,0,1,0-1.06,1.06Z",
				transform: "translate(-254.338 -142.661)",
				fill: "current"
			})]
		})
	})]
});
const ForwardRef = forwardRef(SvgPressure);
export { ForwardRef as ReactComponent };
